
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/plugins/owl-carousel/js/owl.carousel.min';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/widgets/slideshow/js/slideshow';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-260106-3e58dd97/ui-products/wspc/node_modules/ui-core/widgets/slideshow/js/showcase-slideshow';
  
const main = (UX) => {
    const $slider = Array.prototype.slice.call(document.querySelectorAll('.slideshow, .slideShow')),
        $showcaseSlideshow = Array.prototype.slice.call(document.getElementsByClassName('js-showcase-slideshow'))

try {
        if ($slider.length ) {
            UX.slider.init($slider);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($showcaseSlideshow.length ) {
            UX.showcaseSlideshow.init($showcaseSlideshow);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        